import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const emelia = defineConnector({
  identifier: "emelia",
  name: "Emelia",
  tagLine: "Cold email outreach",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: () => "https://graphql\\.emelia\\.io/.*",
  auth: (app) =>
    headerAuth([{ name: "Authorization", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get your API key",
      items: [
        {
          kind: "markdown",
          content:
            "In [Emelia](https://app.emelia.io/), go to **Settings → API** and copy your API key.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://graphql.emelia.io/graphql",
  },
});
